import { Type } from "@sinclair/typebox";
import SchemaValidator from "../../../schema-validator";

const accessCodeDisableEvent = new SchemaValidator(
	Type.Object({
		type: Type.Literal("access code"),
		name: Type.Literal("save password disabled"),
		time: Type.Date(),
		details: Type.Object({
			success: Type.Boolean(),
		}),
	}),
);

const accessCodeResetEvent = new SchemaValidator(
	Type.Object({
		type: Type.Literal("access code"),
		name: Type.Literal("save password reset"),
		time: Type.Date(),
		details: Type.Object({
			success: Type.Boolean(),
		}),
	}),
);

const accessCodeAutofillEvent = new SchemaValidator(
	Type.Object({
		type: Type.Literal("access code"),
		name: Type.Literal("autofill"),
		time: Type.Date(),
		details: Type.Object({
			success: Type.Boolean(),
			password: Type.Optional(Type.String()),
		}),
	}),
);

export default {
	accessCodeDisableEvent,
	accessCodeResetEvent,
	accessCodeAutofillEvent,
};
